import { Box, CircularProgressProps, CircularProgress as MUICircularProgress } from '@mui/material';

export const CircularProgress = (props: CircularProgressProps) => (
  <Box sx={{ display: 'flex', position: 'relative' }}>
    <MUICircularProgress
      variant='determinate'
      role='presentation'
      sx={{
        color: (theme) => theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
      }}
      {...props}
      value={100}
    />
    <MUICircularProgress
      variant='indeterminate'
      sx={{
        animationDuration: '550ms',
        position: 'absolute',
        left: 0,
      }}
      {...props}
    />
  </Box>
);
